import scrollData from '../../../../src/js/globals/scroll';

const Navigation = () => {
  const navigation = document.querySelector('.js-Navigation');

  if (!navigation) return;

  const hamburger = navigation.querySelector('.js-hamburger');
  const close = navigation.querySelector('.js-close-btn');
  const menu = navigation.querySelector('.js-menu');

  const navHeight = (navigation as HTMLElement).offsetHeight;
  const isHome = document.body.classList.contains('home');
  const offset = 50;

  if (!menu) return;

  function handleScroll(e: Event) {
    if (!isHome) return;

    const { scrollY, time } = scrollData(e);

    if (scrollY < navHeight + offset) {
      navigation?.classList.remove('has-scrolled');
      return;
    }

    if (
      scrollY > navHeight + offset &&
      time > 1000 &&
      !navigation?.classList.contains('has-scrolled')
    ) {
      navigation?.classList.add('has-scrolled');
    }
  }

  window.addEventListener('scroll', handleScroll, {
    capture: false,
    passive: true,
  });

  hamburger?.addEventListener('click', () => {
    hamburger?.classList.add('hidden');
    close?.classList.remove('hidden');
    close?.classList.add('flex');
    menu?.classList.add('is-active');
    document.body.dataset.scrollDisable = 'true';
  });

  close?.addEventListener('click', () => {
    hamburger?.classList.remove('hidden');
    close?.classList.remove('flex');
    close?.classList.add('hidden');
    menu?.classList.remove('is-active');
    document.body.dataset.scrollDisable = 'false';
  });
};

export default Navigation;
